import { Pipe, PipeTransform } from '@angular/core';

import { DimsUom, VolumesUom, WeightsUom, ConvertableValues, Convert } from '@library/common/models';

export function DimConvert( amount: number, from: DimsUom, to: DimsUom ): number {
   return Convert( amount, from, to );
}

export function VolConvert( amount: number, from: VolumesUom, to: VolumesUom ): number {
   return Convert( amount, from, to );
}

export function WeightConvert( amount: number, from: WeightsUom, to: WeightsUom ): number {
   return Convert( amount, from, to );
}

export const UomConvertTypes = [ 'dim', 'weight', 'volume' ] as const;
export type UomConvertTypes = typeof UomConvertTypes[number];

@Pipe({ name: 'convertUom' })
export class ConvertUomPipe implements PipeTransform {
   transform( value: number, _type: UomConvertTypes, from: ConvertableValues, to: ConvertableValues ): number {
      return Convert( value, from, to );
   }
}
